//nao usando context nem hooks, nao há necessidade

import { useConditionLayout } from '../ConditionLayout/hooks/useConditionLayout';
import { VtexButton } from '../styleguide/VtexButton';

const AvailabilityNotify = (props: any) => {
	const conditionData = useConditionLayout();
	return (
		<div data-selection={props.componentId} className="notiferContainer vtex-availability-notify-1-x-notiferContainer">
			<div className="title vtex-availability-notify-1-x-title t-body mb3">
				Este produto não está disponível no momento
			</div>
			<div className="notifyLabel vtex-availability-notify-1-x-notifyLabel t-small fw3">
				Quero saber quando estiver disponível
			</div>
			<form className="form vtex-availability-notify-1-x-form mb4">
				<div className="content vtex-availability-notify-1-x-content flex-ns justify-between mt4 mw6">
					<div className="input vtex-availability-notify-1-x-input vtex-availability-notify-1-x-inputName w-100 mr5 mb4">
						<label className="vtex-input w-100">
							<div className="vtex-input-prefix__group flex flex-row items-stretch overflow-hidden br2 bw1 b--solid b--muted-4 hover-b--muted-3 h-regular ">
								<input
									className="vtex-styleguide-9-x-input ma0 border-box vtex-styleguide-9-x-hideDecorators vtex-styleguide-9-x-noAppearance br2   w-100 bn outline-0 bg-base c-on-base b--muted-4 hover-b--muted-3 t-body ph5 "
									name="name"
									placeholder="Nome"
									type="text"
									value=""
								/>
							</div>
						</label>
					</div>
					<div className="input inputEmail vtex-availability-notify-1-x-input vtex-availability-notify-1-x-inputEmail w-100 mr5 mb4">
						<label className="vtex-input w-100">
							<div className="vtex-input-prefix__group flex flex-row items-stretch overflow-hidden br2 bw1 b--solid b--muted-4 hover-b--muted-3 h-regular ">
								<input
									className="vtex-styleguide-9-x-input ma0 border-box vtex-styleguide-9-x-hideDecorators vtex-styleguide-9-x-noAppearance br2   w-100 bn outline-0 bg-base c-on-base b--muted-4 hover-b--muted-3 t-body ph5 "
									name="email"
									placeholder="E-mail"
									type="text"
									value=""
								/>
							</div>
						</label>
					</div>
					<div className="submit vtex-availability-notify-1-x-submit flex items-center mb4">
						<VtexButton
							handleClick={() => {
								if (conditionData?.setConditionIsTrue) {
									const { setConditionIsTrue, conditionIsTrue } = conditionData;
									setConditionIsTrue(!conditionIsTrue);
								}
							}}
						>
							Enviar
						</VtexButton>
					</div>
				</div>
			</form>
		</div>
	);
};

export default AvailabilityNotify;
